import React, { Component } from 'react'
import { Accordion } from './ui/Accordion'
import { ProductCard } from './ui/ProductCard'
import { Component, Zone } from '../utils/types'
interface ComponentSelectionProps {
  components: Component[]
  zones: Zone[]
  onAddComponent: (component: Component, targetZone: Zone | 'all') => void
}
export function ComponentSelection({
  components,
  zones,
  onAddComponent,
}: ComponentSelectionProps) {
  // Group components by category
  const categories = {
    manifold: 'Gulvvarme/Manifolder',
    pipe: 'Rør & C/C',
    thermostat: 'Styring/Termostater',
    pump: 'Shunt/Pumpe/VVX',
    ventilation: 'Ventilation/Kanaler',
    accessory: 'Tilbehør',
  }
  const componentsByCategory = components.reduce(
    (acc, component) => {
      if (!acc[component.category]) {
        acc[component.category] = []
      }
      acc[component.category].push(component)
      return acc
    },
    {} as Record<string, Component[]>,
  )
  return (
    <div className="mt-8">
      <h2 className="text-xl font-medium text-gray-900 mb-4">
        Vælg Komponenter (Mix & Match)
      </h2>
      {Object.keys(categories).map((categoryKey) => (
        <Accordion
          key={categoryKey}
          title={categories[categoryKey as keyof typeof categories]}
          defaultOpen={categoryKey === 'manifold'}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {componentsByCategory[categoryKey]?.map((component) => (
              <ProductCard
                key={component.id}
                component={component}
                zones={zones}
                onAddComponent={onAddComponent}
              />
            ))}
          </div>
          {componentsByCategory[categoryKey]?.length > 6 && (
            <div className="mt-4 text-center">
              <button className="text-red-600 hover:text-red-700 text-sm font-medium">
                Vis flere{' '}
                {categories[
                  categoryKey as keyof typeof categories
                ].toLowerCase()}
              </button>
            </div>
          )}
        </Accordion>
      ))}
    </div>
  )
}
